import React from 'react';
import { connect } from 'react-redux';
import { Combobox } from 'react-widgets';
import { createStructuredSelector } from 'reselect';
import * as profile from '../../../modules/customer/profile';
import * as user from '../../../modules/user';
import { orderProducts, softwareProducts, hardwareProducts } from '../../../modules/customer';
import ActionButton from '../../components/ActionButton';
import LoadingPanel from '../../components/LoadingPanel';
import ShippingSelector from './ShippingSelector';
import { auth0Service } from '../../../common/bootstrap';
import SelectedProduct from './SelectedProduct';
import ProductSelectorItem from './ProductSelectorItem';
import ProductSelectorTabs from './ProductSelectorTabs';

class ProductSelector extends React.Component {

    partnerId = "";

    componentDidMount = () => {
        this.partnerId = auth0Service.getPartnerId();
        this.fetchOffers();
    }

    fetchOffers = () => {
        if (this.partnerId) 
            this.props.fetchPartnerOffers(this.partnerId)
                .then(this.onFetchOffersSuccess, this.onFetchOffersFailure);
    }
    onFetchOffersSuccess = (response) => this.fetchPrices(response.offers);
    onFetchOffersFailure = (response) => console.log('Fetch offer failure');
    fetchPrices = (commercialProductsWithOffers) => this.props.fetchProductPrices(this.props.id, commercialProductsWithOffers);

    // Action
    isActionActive = () => this.props.selectedProduct && !!this.props.selectedProduct.commercialProductId;
    mapProduct = product => ({
        commercialProductId: product.commercialProductId,
        productOfferId: product.offerId,
        type: product.type,
        price: product.price.price,
        contractPeriod: product.contractPeriod

    });
    getBundle = (product) => {
        let bundle = [product];
        // Add free program card
        if (product.commercialProductId === 256) 
            bundle.push({ commercialProductId: 48, productOfferId: 44, contractPeriod: 1 }); 
        return bundle;
    }
    action = () => {
        this.props.saveStart();
        const product = this.mapProduct(this.props.selectedProduct);
        const bundle = this.getBundle(product);
        if (['subscription', 'premium', 'multiroom'].includes(product.type)) this.props.orderSoftware(this.props.id, bundle);
        if (['receiver', 'equipment'].includes(product.type)) this.props.orderHardware(this.props.id, bundle, 166, this.props.shouldSkipShippingOrder);
        setTimeout(this.onSaveComplete, 3000);
    }
    onSaveComplete = () => {
        this.cleanup();
        this.props.saveStop();
        this.props.fetchSoftwareProductsList(this.props.id);
        this.props.fetchHardwareProductsList(this.props.id);
    }
    cleanup = () => this.props.selectProduct({});


    // Combobox selector

    getProductOffers = () => this.props.productOffers.filter(x => x.type === this.props.displayType);
    messages = {
        openCombobox: 'Type number or select from list',
        emptyList: 'No predefined options',
        emptyFilter: 'No predefined options'
    };
    onProductChange = product => {
        if (product._id) this.props.selectProduct(product);
        else this.props.selectProduct({});
    };
    filterProduct = (product = {}, search = '') => {
        const name = product.name || "";
        return name.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    }
    getBoxLabel = (data) => data._id?
        this.props.selectedProduct.name:
        data;
    getBoxPlaceholder = () => `Choose new ${this.props.displayType}`;
    isLoading = () => this.props.isOfferListLoading || this.props.isPriceListLoading || this.props.isSaving;

    // Tabs
    getTabAction = () => (type) => {
        this.cleanup(); 
        this.props.setDisplayType(type)
    }

    render = () => this.isLoading()?
        <LoadingPanel />: 
        <div>
            <ProductSelectorTabs type={this.props.displayType} action={this.getTabAction()} />
            <div className='block'>
                <Combobox
                    data={this.getProductOffers()}
                    textField={this.getBoxLabel}
                    renderListItem={ProductSelectorItem}
                    placeholder={this.getBoxPlaceholder()}
                    onChange={this.onProductChange}
                    filter={this.filterProduct}
                    messages={this.messages}        
                    
                />
            </div>
            <SelectedProduct {...this.props.selectedProduct} />
            <div className="block">
                <ShippingSelector />
            </div>
            <div className='button-panel-horizontal clearfix text-right'>
                <ActionButton to={'/#/customer/' + this.props.id} className='big gray' title='Avbryt' />
                <ActionButton action={this.action} className='big green' title='Bekreft' active={this.isActionActive()} />
            </div>
        </div>
}

const mapStateToProps = createStructuredSelector({
    id: profile.selectors.getCustomerID,
    partnerId: user.selectors.getPartnerId,
    softwareProductList: softwareProducts.selectors.getSoftwareProductsList,
    hardwareProductList: hardwareProducts.selectors.getHardwareProductList,
    productOffers: orderProducts.selectors.getProductOffers,
    isSoftwareLoading: softwareProducts.selectors.isLoading,
    isHardwareLoading: hardwareProducts.selectors.isLoading,
    isPriceListLoading: orderProducts.selectors.isPriceListLoading,
    isOfferListLoading: orderProducts.selectors.isOfferListLoading,
    selectedProduct: orderProducts.selectors.getSelectedProduct,
    displayType: orderProducts.selectors.getDisplayType,
    isSaving: orderProducts.selectors.isSaving,
    shouldSkipShippingOrder: orderProducts.selectors.shouldSkipShippingOrder
});

const mapDispatchToProps = (dispatch, props) => ({
    orderSoftware: (customerId, commercialProductsWithOffers) => dispatch(orderProducts.actions.orderSoftware(customerId, commercialProductsWithOffers)),
    orderHardware: (customerId, commercialProductsWithOffers, customerOfferId, skipShippingOrder) => 
        dispatch(orderProducts.actions.orderHardware(customerId, commercialProductsWithOffers, customerOfferId, skipShippingOrder)),
    selectProduct: product => dispatch(orderProducts.actions.selectProduct(product)),
    saveStart: () => dispatch(orderProducts.actions.saveStart()),
    saveStop: () => dispatch(orderProducts.actions.saveStop()),
    fetchSoftwareProductsList: (customerId) => dispatch(softwareProducts.actions.fetchSoftwareProductsList(customerId)),
    fetchHardwareProductsList: (customerId) => dispatch(hardwareProducts.actions.fetchHardwareProductsList(customerId)),
    fetchProductOffers: () => dispatch(orderProducts.actions.fetchProductOffers()),
    fetchPartnerOffers: (partnerId) => dispatch(orderProducts.actions.fetchPartnerOffers(partnerId)),
    fetchProductPrices: (customerId, commercialProductsWithOffers) => dispatch(orderProducts.actions.fetchProductPrices(customerId, commercialProductsWithOffers)),
    setDisplayType: (type) => dispatch(orderProducts.actions.setDisplayType(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductSelector);
